import { useState } from "react";
import { Printer } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "@/contexts/LanguageContext";
import { downloadQuizPDF } from "@/utils/quizPdf";

export default function PrintQuizButton({ path, title, testId, compact = false }) {
  const { lang } = useTranslation();
  const es = lang === "es";
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try {
      await downloadQuizPDF(path, title, lang);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={run}
      disabled={busy}
      title={es ? "Imprimir cuestionario (PDF con clave de respuestas)" : "Print quiz (PDF with answer key)"}
      className="border-white/15 text-[#D4D4D8] hover:bg-white/5"
      data-testid={testId}
    >
      <Printer weight="bold" className={`w-4 h-4 ${compact ? "" : "mr-1.5"}`} />
      {!compact && (busy ? (es ? "Generando..." : "Generating...") : es ? "Imprimir (PDF)" : "Print (PDF)")}
    </Button>
  );
}
